"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.253 5.088c.293.326.545.674.75 1.006.206-.33.46-.677.753-1.004.714-.792 1.666-1.46 2.748-1.455 2.1.01 3.496 1.27 3.496 4.108 0 3.412-4.962 7.32-6.529 8.469a.785.785 0 0 1-.935-.002C7.97 15.05 3 11.106 3 7.743c0-2.55 1.397-4.108 3.5-4.108 1.093 0 2.043.662 2.753 1.453Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HeartFilledIcon20.js.map